import { Card, Divider, Typography, Row, Col, Button } from "antd";
import {
  LeftOutlined,
  EditOutlined,
  LockOutlined,
  DeleteOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import toast from "react-hot-toast";
import { capitalizeName, formatDateFunction } from "../../../utils/helper/utils";

const SubAdminDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [subAdminDetail, setSubAdminDetail] = useState(null);

  const getSubAdminDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_SUBADMIN.GET_DETAIL + "/" + id, "get", {}, {}, true)
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setSubAdminDetail(apiResponse?.data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getSubAdminDetail(id);
  }, []);

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
              Sub Admin Details
            </Typography>
          </div>
        </div>
        <Divider />
        <div>
          <Row>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Name</div>
                <div className="text-sm">
                  {capitalizeName(subAdminDetail?.firstName)}{" "}
                  {capitalizeName(subAdminDetail?.lastName)}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Email Address</div>
                <div className="text-sm">{subAdminDetail?.email || "-"}</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Mobile Number</div>
                <div className="text-sm">{subAdminDetail?.mobileNo || "-"}</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Role</div>
                <div className="text-sm">
                  {capitalizeName(subAdminDetail?.rolePermission?.subadminRoleName) || "-"}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Account created on</div>
                <div className="text-sm">
                  {subAdminDetail?.createdAt
                    ? formatDateFunction(subAdminDetail.createdAt, "dd/mm/yyyy")
                    : "-"}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Status</div>
                <div className="text-sm">
                  {capitalizeName(subAdminDetail?.status) || "-"}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
};
export default SubAdminDetails;
